<template>
    <EmailPasswordAuth>
        <div class="min-h-screen w-full">
            <LeftNavigation v-if="!route.path.startsWith('/data-ops')" />

            <router-view />
        </div>
        <ViewProviderSearch />
    </EmailPasswordAuth>
</template>

<script setup>
import { defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'
import EmailPasswordAuth from '@/components/EmailPasswordAuth.vue'
import LeftNavigation from '@/components/LeftNavigation.vue'

// Hidden modal until opened; split out of the entry chunk so it loads after the shell paints.
const ViewProviderSearch = defineAsyncComponent(() => import('@/features/provider-search/views/ProviderSearchView.vue'))

const route = useRoute()
</script>
